export default function publishToOneApp(event) {
  window.top.postMessage(JSON.stringify(event), '*');
}
